<template>
  <div id="main-view">
    <Header v-if="!$route.path.endsWith('/home')" :class="{ isModalOpen: applyClass }" />
    <div 
    id="main-router-frame" 
    v-if="!['alarm', 'home'].includes(firstPath)" 
    :class="[
    { setting: firstPath == 'user' && subPath == 'setting' },
    { 'trading': firstPath == 'trading-view' },
    { 'setting-detail': firstPath == 'user' && subPath !== 'setting' },
    { 'board-detail' : (firstPath == 'board' && subPath !== 'ai-brief') && (firstPath == 'board' && subPath !== 'notice')}
    ]">
      <router-view></router-view>
    </div>
    <div id="alarm-router-frame" v-else>
      <router-view></router-view>
    </div>
    <Footer :class="{ isModalOpen: applyClass }" />
    <ScrollTopBtn v-if="firstPath != 'price' && subPath != 'price-alarm'" :class="[
      { isModalOpen: clickCoin },
      { isModalOpen: subPath === 'plus-coin' || firstPath === 'board' || firstPath === 'user' },
    ]" />
    <ScrollTopBtn v-else-if="firstPath != 'price' && subPath == 'price-alarm'" :class="{ isModalOpen: clickAlarm }" />

  </div>
</template>

<script>
import "@/assets/css/reset.css";
import "@/assets/css/normalize.css";
// import "@/assets/css/setting.css";
// import "@/assets/css/modal.css";
import "@/assets/css/style_dark.css";
import "@/assets/css/main.css";
import "@/assets/css/home.css";
import "@/assets/css/price.css";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { mapState } from "vuex";

import { addScrollHandler, removeScrollHandler } from "@/utils/scroll.js";
import ScrollTopBtn from "@/components/button/ScrollTopBtn.vue";
// import MsgModal from "@/components/modal/MsgModal.vue";

import api from "@/api/apiAuth.js";

// 다국화
// import { computed } from 'vue';
import "@/utils/localeTime.js"
import { useI18n } from "vue-i18n";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    ScrollTopBtn,
    // MsgModal,
  },
  data() {
    return {
      test: "",
      loginData: null,
      userId: localStorage.setItem("userId", 0),
      userNum: localStorage.setItem("userNum", "retri0"),
      userName: localStorage.setItem("userName", "GoyaLove1004"),
      selectLocale: localStorage.getItem("localeLang"),
      regionCode: localStorage.getItem("regionCode"),
      selectedTheme: localStorage.setItem("selectedTheme", "default"),
    };
  },
  provide() {
    return {
      loginData: this.loginData,
    };
  },
  setup() {
    const { t, locale } = useI18n({ useScope: "global" });
    return {
      t,
      locale,
    };
  },
  computed: {
    ...mapState("coinReg", ["clickCoin", "clickGuide"]),
    ...mapState("alarmReg", ["clickAlarm", "editAlarm"]),
    ...mapState("rsiTrade", ["clickTrade"]),
    ...mapState("board", ["clickAM", "clickPM", "clickNotice", "clickFAQ"]),
    path() {
      return this.$route.path;
    },
    firstPath() {
      return this.path.split("/")[1];
    },
    subPath() {
      return this.path.split("/")[2];
    },
    thirdPath() {
      return this.path.split("/")[3];
    },
    userState() {
      ``
      return this.firstPath == "user" && this.subPath != "setting";
    },
    applyClass() {
      return (
        this.clickCoin ||
        this.clickAlarm ||
        this.clickTrade ||
        this.clickAM ||
        this.clickPM ||
        this.clickNotice ||
        this.clickFAQ ||
        this.clickGuide ||
        this.subPath == 'insight-coin' ||
        this.subPath == 'change-coin' ||
        this.subPath == 'guide' ||
        this.subPath == 'guide-pdf' ||
        this.thirdPath == 'fav-coin'
      );
    },
  },
  methods: {
    async receiveLoginData(data) {
      this.loginData = data;
      const accessToken = this.loginData?.data?.accessToken;
      const userNum = this.loginData?.data?.member?.userId;
      const userName = this.loginData?.data?.member?.nickname;
      api.setAuthToken(accessToken);
      this.userId = localStorage.setItem("userId", accessToken);
      this.userNum = localStorage.setItem("userNum", userNum);
      this.userName = localStorage.setItem("userName", userName);
      this.$store.dispatch('loginStatus/updateLoginStatus', true);
   
      await api.chkSubscribe();
    },
    async updateLocale() {
      const newLocale = localStorage.getItem('localeLang') || 'en';
      this.$i18n.locale = newLocale;
      const newRegionCode = localStorage.getItem('regionCode') || 'UTC';
      this.regionCode = newRegionCode;
    },
  },
  created() {
    if (process.env.NODE_ENV === "development") {
      // 테섭
      let token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiQUNDRVNTX1RPS0VOIiwic3ViIjoidGVzdDU1NSIsImF1dGgiOiJST0xFX1JFVFJJIiwidXNlcklkIjoyMDQzOTEsInJldHJpSWQiOiJtRVYrZFlPd3c0TXZ0MXo4YndmTExWeUNHYUJjQWhicktQV2JzaVVLVlB3WS9SS0VlRy8zaHYrZTFtWkNUdnljemtTd2QrTDIzY3pWRG43N2t2T1hRUzVPL2dRMW8zTTc1dktVc3ZKL0pYYmcwSEhveFpLYjUxT2xLV1lESGtFalNjZ3YweWRRTEtXZTRmTEtQcDNndTloeFUwazNhM1dWWmN3RXJDRGpBMU1hRnh5RWkyMWI0MHlmYUg3VnBGRHAvVVdzSmhPelNpVlBwVFZlemxWRlFhOTFuRjFRa3FIdGFlWTZOYU11d2g0Z3JrZUJkY2JKUFFIY3plL0Urc01nbTc2VXUzdW9yQWg4aFF3SHlPeDVrMDdBK1NmSDlsZ28xbENSV3FzRUd1N2RuSXdEbXc4NVZHdmEreDBLdkdOalRobVg5NlNVQXVtd0F0aVhMYkNZT3c9PSIsImRhdGUiOiJPUDh4aXVoNUl5em11N1VXc1g3clJRZEhFN3RFMU9RL1BTZktlUjJVditGSWdvZWl1c1FZU2lOQldJZkVTemd6ZmNjVzUwTG1HaGRBWXI4ak02OVF4NEd3a2JGcTR1RDY5ekdEdHBxQTNHdTNJcWxPU3FNQzVtZVIvbVBKWmgvVGV0SWQvSmRGbkxnekFkMWlobHpXR0dtREcwTXJhY2pxM2NrdVU0dE9MM2RpNFpvSmQxVjVoRHN5UUp1QlBIaUFQQ0JsYnhJOHJiTGhmZ09DcVJ6TUluNkZPL3RVUEVJMkYwWE9oQVpZb0M3UnQ2RmlqWDFaQnQ3Ty8wRnRVWUhrbk5uWGdEVkNQSHBaOXhLMzBpczZKZXlUY3dHdE5zditiYVowQWpYbzJXcUE4M0JlcGtTRmhueW9UVjlyY0JGL3U3b1NEK24xYTRNSHp5dndjTURyOXc9PSIsImlhdCI6MTc4NjM1NzM1NiwiZXhwIjoxODE3ODkzMzU2fQ.IqreELix71_WSjl-VHt5jefW1NG4fsoN9AbMGWMMfZ8"
      api.setAuthToken(token);
      this.userId = localStorage.setItem("userId", token);
      
      // 실섭
      // api.setAuthToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiQUNDRVNTX1RPS0VOIiwic3ViIjoidGVzdDA3IiwiYXV0aCI6IlJPTEVfUkVUUkkiLCJ1c2VySWQiOjIwNDM3OSwicmV0cmlJZCI6Ik9LcWwrWDlrRmNPZWllaytEdzJSd1MrRE9WbXIvb3pjQy9URjR1cEhkazhjdE9oRk1GVkF1UUJNRklNaHZOdHI4SFJBYnpGZUY2dFpBa3Z3cWJsY3dvbnhiYkdNSmhrUEcwUU9zMFJvN3BESkh2MlJvYUhCb1dyV0o1NVNWaE01ZFpteEhwbWo3SzlsSmlmblJMUGxXVi9NcUh1bTF6aDE4d0dEUkU0M2c0T1k0Z2hqVUFrbW1GU1FkNHVwTFJMSnIzTnpPeVhkWUdBdWtKdmZmTTVrM2Q1Tkg5eGlLVExVUUhrTjIvblMwSXZQOGJsOVZ1N0dHNVJxS0MvbFExakR1UmZMa25FeEhUWHVjTFdxaFBmTlN0NjRqNGQ1K2RpY2pBK3RuWWhIUjZhekRhQTc5R1haV05LNHpZN3VEaFc2RHo2RnBNK3pvTXJoTm03djdydG92QT09IiwiZGF0ZSI6ImY1UFZpN3FkU0hKQ3RHOVhZRldMSU4wR0ZFZGJoZFBGUUxML0hyQnF6cDZUVTlOOGhNaG56R2tNQ3JkWnUyWVFMNERVWElsTWZxNUt5Sy9RM0IvNU1SNm5ITE1SSlpJcFV4dVZNV3V3TDYzNnFzVEwvOUwwU1QvUFJyamsxbU05WVBIcjZGdTZPdHp6akFSemJQSFkwcGlTSFYwZEVOc0lrZ0MxK1hqYXYrYklRV0VTV2NKdFczZW8zMlZyMlB6T1pjenppdVZxZGZTL0RESFhZQWk2d2Q3dG91MXByRGVHVFR1RUlCaDdtSWgzaVp0c1h3ZEVNekRMM0d5OTNuYTZhT2RZQ3Z4VWE4TStPZmdwWVpqS2ZMSHlNcWJHZjQ0RDcyYlRKMHdNdk1pZDZiR0xpeTc1RlQvNzBWWWxoMERhcC9Id2wrUnBocHNCZGgwY01EZ0c5Zz09IiwiaWF0IjoxNzcxNTcwNTI3LCJleHAiOjE4MDMxMDY1Mjd9.10eRSkL2pK1xQE37MBzvfWhqgMYV3ILD1JxeLKVMpGA");
      // this.userId = localStorage.setItem("userId", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiQUNDRVNTX1RPS0VOIiwic3ViIjoidGVzdDA3IiwiYXV0aCI6IlJPTEVfUkVUUkkiLCJ1c2VySWQiOjIwNDM3OSwicmV0cmlJZCI6Ik9LcWwrWDlrRmNPZWllaytEdzJSd1MrRE9WbXIvb3pjQy9URjR1cEhkazhjdE9oRk1GVkF1UUJNRklNaHZOdHI4SFJBYnpGZUY2dFpBa3Z3cWJsY3dvbnhiYkdNSmhrUEcwUU9zMFJvN3BESkh2MlJvYUhCb1dyV0o1NVNWaE01ZFpteEhwbWo3SzlsSmlmblJMUGxXVi9NcUh1bTF6aDE4d0dEUkU0M2c0T1k0Z2hqVUFrbW1GU1FkNHVwTFJMSnIzTnpPeVhkWUdBdWtKdmZmTTVrM2Q1Tkg5eGlLVExVUUhrTjIvblMwSXZQOGJsOVZ1N0dHNVJxS0MvbFExakR1UmZMa25FeEhUWHVjTFdxaFBmTlN0NjRqNGQ1K2RpY2pBK3RuWWhIUjZhekRhQTc5R1haV05LNHpZN3VEaFc2RHo2RnBNK3pvTXJoTm03djdydG92QT09IiwiZGF0ZSI6ImY1UFZpN3FkU0hKQ3RHOVhZRldMSU4wR0ZFZGJoZFBGUUxML0hyQnF6cDZUVTlOOGhNaG56R2tNQ3JkWnUyWVFMNERVWElsTWZxNUt5Sy9RM0IvNU1SNm5ITE1SSlpJcFV4dVZNV3V3TDYzNnFzVEwvOUwwU1QvUFJyamsxbU05WVBIcjZGdTZPdHp6akFSemJQSFkwcGlTSFYwZEVOc0lrZ0MxK1hqYXYrYklRV0VTV2NKdFczZW8zMlZyMlB6T1pjenppdVZxZGZTL0RESFhZQWk2d2Q3dG91MXByRGVHVFR1RUlCaDdtSWgzaVp0c1h3ZEVNekRMM0d5OTNuYTZhT2RZQ3Z4VWE4TStPZmdwWVpqS2ZMSHlNcWJHZjQ0RDcyYlRKMHdNdk1pZDZiR0xpeTc1RlQvNzBWWWxoMERhcC9Id2wrUnBocHNCZGgwY01EZ0c5Zz09IiwiaWF0IjoxNzcxNTcwNTI3LCJleHAiOjE4MDMxMDY1Mjd9.10eRSkL2pK1xQE37MBzvfWhqgMYV3ILD1JxeLKVMpGA");
    }

    if (process.env.NODE_ENV === "production") {
      window.receiveLoginData = this.receiveLoginData.bind(this);
      window.updateLocale = this.updateLocale.bind(this);
    }
  },

  mounted() {
    addScrollHandler();

  },
  unmounted() {
    // 페이지 이동시 핸들러 삭제
    removeScrollHandler();
  },
  beforeUpdate() {
    // 라우터 이동시 핸들러 삭제
    removeScrollHandler();
  },
  updated() {
    // 라우터 이동후 핸들러 추가
    addScrollHandler();
  },
};
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100dvh;
}

.isModalOpen {
  display: none !important;
}

.show {
  display: block !important;
}

.boardNone {
  display: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  max-height: 0px;
}

.fade-leave-from,
.fade-enter-to {
  max-height: 240px;
}
</style>
